import { Action } from './action.ts';
import { L } from './utils.ts';

export const dispatch = (action: Action) => {
  try {
    if (amusic.port) {
      const data = JSON.stringify(action);
      L.log('Dispatching action:', data);
      amusic.port.postMessage(data);
    } else {
      L.error('Port is not available');
    }
  } catch (error) {
    L.error('Error dispatching action:', error);
  }
};
